// extracted by mini-css-extract-plugin
export default {"loader":"dropdown-basic_loader__ff9OO","spin":"dropdown-basic_spin__iP7Md","container":"dropdown-basic_container__rnvUe"};